import React from 'react';
import { Instagram, Mail, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zinc-950 py-24 md:py-32 px-6 border-t border-zinc-900" data-id="element-22">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-23">
        <p className="font-mono text-[11px] md:text-xs uppercase tracking-[0.4em] text-white/40 font-light" data-id="element-24">
          El océano te está esperando
        </p>

        <h2 className="mt-10 md:mt-12 font-heading text-2xl md:text-4xl font-medium uppercase tracking-[0.15em] text-white" data-id="element-25">
          Buceo y Navegación
        </h2>

        <div className="mt-12 md:mt-16 flex items-center gap-8" data-id="element-26">
          <a href="https://wa.me/5491122836110" target="_blank" rel="noopener noreferrer" className="text-zinc-500 hover:text-blue-400 transition-colors" aria-label="WhatsApp" data-id="element-27">
            <MessageCircle className="w-5 h-5" strokeWidth={1.5} data-id="element-28" />
          </a>
          <a href="https://instagram.com/buceoynavegacion" target="_blank" rel="noopener noreferrer" className="text-zinc-500 hover:text-blue-400 transition-colors" aria-label="Instagram" data-id="element-29">
            <Instagram className="w-5 h-5" strokeWidth={1.5} data-id="element-30" />
          </a>
          <a href="mailto:buceoynavegacion@gmail.com" className="text-zinc-500 hover:text-blue-400 transition-colors" aria-label="Email" data-id="element-31">
            <Mail className="w-5 h-5" strokeWidth={1.5} data-id="element-32" />
          </a>
        </div>
      </div>
    </footer>;
}